import{dateNow}from"./dateNow";export var getEndTime=function(until){return dateNow()+until*1e3};
//# sourceMappingURL=getEndTime.js.map